import React, { FC, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addFilters, clearFilters } from "store/table/table.slice";
import { AppState } from "store/types";
import CrossIcon from "assets/Icons/replenishment/CrossIcon.svg";
import { SellersProps } from "components/types";
import { removeSelectedSeller } from "store/auth/auth.slice";

const SellerListItem: FC<SellersProps> = ({ id, name, checked, index }) => {
  const selectedSellers = useSelector(
    (state: AppState) => state.auth.selectedSellers
  );

  const changeFilter = (id: string) => {
    const filterSellers = selectedSellers
      .map((item: SellersProps) => {
        if (item.id === id) return { ...item, checked: false };
        return item;
      })
      .filter((item: SellersProps) => {
        if (item.checked) return item;
      })
      .map((item: SellersProps) => item.id);
    if (filterSellers.length)
      dispatch(addFilters(["seller_id", filterSellers]));
    else dispatch(clearFilters());
  };

  const dispatch = useDispatch();

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        width: "fit-content",
        margin: "0 2px",
      }}
    >
      <span style={{ color: "#0D47A1" }}>{name}</span>

      <img
        className="icon"
        src={CrossIcon}
        style={{
          marginTop: "1px",
          marginLeft: "4px",
          cursor: " pointer",
        }}
        onClick={() => {
          dispatch(removeSelectedSeller(id));
          changeFilter(id);
        }}
      />
    </div>
  );
};

export default SellerListItem;
